import styled from "styled-components"
import { getCssSizeValue, getHtmlFromRedactorField } from "@/utils/utils"
import Text from "@/components/common/Text"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled.div`
	width: 100%;
	border: 1px solid ${({ theme }) => theme.colors.richBlack};
	border-top: none;
	transition: all var(--rgr-duration) var(--ease);
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	&.hover {
		background: ${({ theme }) => theme.colors.periwinkle};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
	}
`

const Badge = styled.div`
	background: ${({ theme }) => theme.colors.richBlue};
	color: ${({ theme }) => theme.colors.whiteSmoke};
	padding: ${getCssSizeValue(13, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	margin: 0 ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(16)} ${getCssSizeValue(24)};
		margin: 0 ${getCssSizeValue(16)};
	}
`

const HeaderDescriptionWrapper = styled.div`
	color: ${({ theme }) => theme.colors.richBlack};
	display: flex;
	flex-direction: column;
	padding-top: unset;
	padding: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(24)};
	}

	.header {
		margin-bottom: ${getCssSizeValue(16)};
	}
`

function getTileData(data) {
	return {
		header: data?.header || "",
		title: data?.title || "",
		description: data?.description || "",
	}
}

export default function RestTile({ data, isLastTile, index, isLastElementHovered, handleHoverElement, handleClickLastElement }) {
	const { header, title, description } = getTileData(data)
	const className = isLastTile ? "col-desktop-7 col-tablet-8 col-mobile-8" : "col-desktop-4 col-tablet-4 col-mobile-8"
	const isLastClassName = isLastTile ? "last" : ""
	const isHovered = isLastElementHovered && isLastTile ? "hover" : ""

	return (
		<Wrapper
			onClick={handleClickLastElement}
			className={`${className} ${isLastClassName} ${isHovered}`}
			onMouseEnter={() => handleHoverElement(index)}
			onMouseLeave={() => handleHoverElement(-1000)}
		>
			<Badge className="typo-borna typo-borna-105">{header}</Badge>
			<HeaderDescriptionWrapper>
				<div className="header typo-borna typo-borna-109">{title}</div>
				<Text className="typo-strawford typo-strawford-14" dangerouslySetInnerHTML={getHtmlFromRedactorField(description)} />
			</HeaderDescriptionWrapper>
		</Wrapper>
	)
}
